function isRetina() {

	var mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5),\
			(min--moz-device-pixel-ratio: 1.5),\
			(-o-min-device-pixel-ratio: 3/2),\
			(min-resolution: 1.5dppx)";
	if (window.devicePixelRatio > 1)
		return true;
	if (window.matchMedia && window.matchMedia(mediaQuery).matches)
		return true;
	return false;
};


function isElementInViewport (el, completely = false) {

    //special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    if (completely) {

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= jQuery(window).height() &&
            rect.right <= jQuery(window).width()
        );

    } else {

        return (
            rect.top >= (-rect.height) &&
            rect.left >= 0 &&
            rect.bottom <= (jQuery(window).height() + rect.height) &&
            rect.right <= jQuery(window).width()
        );
    }

    
}